<button mat-button class="ribbon-button-padding">
        <mat-icon class="add-icon" [class]="theme.myIconColor">add</mat-icon> 
        <span>Add</span> 
</button>